import { Helmet } from "react-helmet-async";

const BASE = "https://walessecurity.uk";

const Seo = ({ title, description, jsonLd, lang, path = "/", altEn, altCy, noindex }) => {
  const canonical = `${BASE}${path}`;
  return (
    <Helmet>
      <html lang={lang || "en-GB"} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? (
        <meta name="robots" content="noindex, follow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      )}
      <link rel="canonical" href={canonical} />
      {altCy && <link rel="alternate" hrefLang="en" href={canonical} />}
      {altCy && <link rel="alternate" hrefLang="cy" href={`${BASE}${altCy}`} />}
      {altEn && <link rel="alternate" hrefLang="cy" href={canonical} />}
      {altEn && <link rel="alternate" hrefLang="en" href={`${BASE}${altEn}`} />}
      {(altEn || altCy) && <link rel="alternate" hrefLang="x-default" href={altEn ? `${BASE}${altEn}` : canonical} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Xtreme Protection — Wales Security Services" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={lang === "cy" ? "cy_GB" : "en_GB"} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
